<template>
    <div>
        <div class="d-flex flex-wrap align-items-center justify-content-between">
            <div v-if="text" class="pr-2 pay-text">Click the <strong>'Make a payment'</strong> button to attempt payment for past due invoices.</div>
            <button v-if="!paying" @click.prevent="payPastDue()" class="btn btn-form my-2">Make a payment</button>
            <pulse-loader v-else :loading="true" :color="'#E57722'"
                          :size="'20px'"></pulse-loader>
        </div>
        <div v-if="payError" class="alert alert-error my-2">
            {{ payError }}
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapState} from "vuex";
    import {axiosApi, axiosWeb} from "@/js/axios";
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

    import {loadStripe} from '@stripe/stripe-js';

    export default {
        components: {
            PulseLoader
        },
        props: {
            text: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                // Paying past due invoices
                payError: false,

                stripe: null,
            }
        },
        computed: {
            ...mapState('user', {
                paying: 'paying_invoices'
            }),
            ...mapState('shared', [
                'stripeKey',
                'stripeOptions'
            ]),
        },
        mounted() {
            this.loadStripe();
        },
        methods: {
            async loadStripe() {
                this.stripe = await loadStripe(this.stripeKey);
            },
            payPastDue() {
                const $this = this;

                $this.$store.commit('user/SET_PAYING_INVOICES', true);
                this.payError = null;
                this.paySuccess = false;

                return axiosWeb.post(`/api/v1/invoices/past-due/pay`, {}).then(response => {

                    $this.$store.commit('user/SET_PAYING_INVOICES', false);

                    $('.warning-banner').hide();

                    $this.payError = null;

                    $this.$emit('success');

                    $this.$store.dispatch('user/setUser',{
                        user: response.data
                    });

                    setTimeout(() => window.location.reload(), 2000);
                }).catch((error) => {

                    if (error.response.status === 402) {
                        if (error.response.data.error.code === "invoice_payment_intent_requires_action") {
                            return this.authorizePaymentIntent();
                        }
                    }

                    $this.$emit('error');
                    $this.$store.commit('user/SET_PAYING_INVOICES', false);
                    if (error.response.status === 500) {
                        $this.payError = error.response.data;
                        setTimeout(() => this.payError = false, 4000);
                    }
                })
            },

            // Authorize payment SCA
            authorizePaymentIntent() {
                const $this = this;
                this.retrievePaymentIntent()
                    .then( data => {
                        $this.confirmCardPayment(data);
                    })
                    .catch( error => {
                        $this.$emit('error', error.error.message);
                        $this.$store.commit('user/SET_PAYING_INVOICES', false);
                    });
            },

            retrievePaymentIntent() {
                return new Promise((resolve, reject) => {
                    axiosWeb.post(`/api/v1/invoices/past-due/payment-intent`, {})
                        .then( ({data}) => {
                            return resolve(data);
                        })
                        .catch( error => {
                            return reject(error);
                        });
                });
            },

            confirmCardPayment(data) {
                const $this = this;
                $this.stripe.confirmCardPayment(data.client_secret, {
                        payment_method: data.source_id,
                    })
                    .then((result) => {
                        if (result.hasOwnProperty('error')) {
                            $this.payError = result.error.message;
                            return $this.$store.commit('user/SET_PAYING_INVOICES', false);
                        }

                        if (result.hasOwnProperty('paymentIntent')) {
                            setTimeout(() => window.location.reload(), 2000);
                            $this.$emit('success');
                            return $this.$store.commit('user/SET_PAYING_INVOICES', false);
                        }
                    });
            }
        },
    }
</script>

<style lang="scss">
    .pay-text {
        max-width: 480px;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/settings/PayPastDueInvoices.vue